import defaultTheme from './defaultTheme';
import constants from '../../constants';

export default {
  ...defaultTheme,
  inputBackground: constants.Colors.newBackground,
  layer1: constants.Colors.RegalBlue,
  layer2: constants.Colors.newBackground,
  contactUsItem: constants.Colors.MidnightNavy,
  contactUsLabel: constants.Colors.PattensBlue,
  contactUsValue: constants.Colors.White,
  contactUsCustomerLabel: constants.Colors.White,

  //for edit profile
  editProfileLabel: constants.Colors.White,
  editProfileRadioBtnBorder: constants.Colors.GreyBlue2,
  editProfileRadioBtn: '#040628',
  editProfileRadioInnerCircle: '#00ab5e',
  editProfileSubmitBtn: '#f6324b',
  editProfileSubmitText: '#fff',
  editProfileTextInputBG: '#040628',
  editProfileTextInputErrorBG: '#141c41',
  editProfileTextInputColor: '#fff',
  editProfileTextInputPlaceHolder: '#555a78',
  editProfileTextInputError: '#f6324b',

  ///for action sheet modal
  actionSheetHeaderLabel: constants.Colors.White,
  actionSheetBtnLabel: constants.Colors.White,
  actionSheetTakePhotoBtn: 'red',
  actionSheetChooseLibBtn: 'green',
  actionSheetContainer: constants.Colors.DarkBlue1,

  //for verify Account Item
  verifyAccountItemContainer: '#303a6d',
  verifyAccountItemContainerBorder: constants.Colors.RegalBlue,
  verifyAccountItemTitle: constants.Colors.White,
  verifyAccountItemContentWrapperBorder: '#7689b4',
  verifyAccountItemText: constants.Colors.PattensBlue,
  verifyAccountItemViewBtn: constants.Colors.Blue,
  verifyAccountItemViewText: constants.Colors.White,
  verifyAccountItemDefault: '#7689b4',
  verifyAccountItemDefaultText: '#fff',
  verifyAccountItemStatusTitle: constants.Colors.PattensBlue,
  verifyAccountItemStatusValue: constants.Colors.PattensBlue,
  verifyAccountItemDefaultButton: constants.Colors.Blue,
  verifyAccountItemVerifyButton: constants.Colors.Lime,
  verifyAccountItemDefaultButtonText: constants.Colors.White,
  verifyAccountItemIcon: constants.Colors.White,

  // for settings screen
  settingScreenTest: '#000',
  settingScreenTitle: '#fff',
  settingOptionBackground: 'rgb(48, 58, 109)',
  settingOptionTextColor: constants.Colors.White,

  //for pdf viewer
  pdfViewerBackground: '#fff',

  //for leaderboard user Profile
  leaderBoardProfileContainer: constants.Colors.RegalBlue,
  leaderBoardHeaderContainer: constants.Colors.RegalBlue,
  leaderBoardContestStatusContainer: constants.Colors.DarkBlue,
  leaderBoardPhotoBackground: constants.Colors.RegalBlue,
  leaderBoardPhotoBorder: '#fff',
  leaderBoardHeaderTitle: '#fff',
  leaderBoardHeaderValue: '#fff',
  leaderBoardContestStatusText: '#fff',
  leaderBoardContestStatusNameTitle: '#fff',
  leaderBoardVsText: '#fff',
  leaderBoardDivider: '#fff',

  //for referral and earn
  referEarnContentBG: '#040628',
  referEarnLabel: '#fff',
  referEarnCodeBorder: constants.Colors.Manatee,
  referEarnCode: '#fff',
  referEarnTapToCopy: '#f5314a',
  referEarnMessage: constants.Colors.solitude,
  referEarnShareBtn: '#f5314a',
  referEarnShareBtnTitle: '#fff',

  //for analytics
  revenueAnalyticsBtnBG: '#f5314a',
  revenueAnalyticsBtnLabel: '#fff',
  revenueAnalyticsSubmitBtnBG: '#040628',
  revenueAnalyticsSubmitBtnLabel: '#fff',
  revenueAnalyticsCardBG: '#040628',
  revenueAnalyticsCardTitle: '#fff',
  revenueAnalyticsSpinner: '#fff',

  //for iframe page
  iframeLoader: '#fff',
  iframeLoaderMessage: '#fff',

  //for minigames leaderboard

  leaderBoardGameInfoBg:
    'transparent linear-gradient(121deg, #212931 0%, #202B36 100%) 0% 0% no-repeat padding-box',
  leaderBoardGameInfoBoxShadow: '3px 0px 12px #000000',
  leaderBoardGameInfoBorder: '#3D4A5C',
  leaderBoardPlayAgainContainerBg:
    'transparent linear-gradient(129deg, #212931 0%, #202B36 100%) 0% 0% no-repeat padding-box',
  leaderBoardPlayAgainContainerBoxShadow: '3px 0px 12px #000000',
  leaderBoardPlayAgainContainerBorder: '#3D4A5C',
  leaderBoardPlayAgainBtnBg:
    'transparent linear-gradient(180deg, #F6C53F 0%, #FFC300 100%) 0% 0% no-repeat padding-box',
  leaderBoardPlayAgainBtnBoxShadow: 'inset 0px 2px 15px #F6FF0063',
  leaderBoardPlayAgainBtnBorder: '#FFF079',
  leaderBoardPlayAnotherGameBtnBg: 'transparent',
  leaderBoardPlayAnotherGameBtnBorder: '#FFC400',
  leaderBoardPlayAnotherGameBtnColor: '#FFC400',
  leaderBoardTableBorder: '#596779',
  leaderBoardTableHeaderBg:
    'transparent radial-gradient(closest-side at 50% 50%, #404F61 0%, #2B3746 100%) 0% 0% no-repeat padding-box',
  leaderBoardTableHeaderBoxShadow: '0px -2px 23px #020722B3',
  leaderBoardTableHeaderColor: 'white',
  leaderBoardRowStyleBg: '#1E242B 0% 0% no-repeat padding-box',
  leaderBoardRowStyleBgDefault: '#0D121A 0% 0% no-repeat padding-box',
  //minigameslobby
  minigamesGameWinningTimerWrapperBg:
    'transparent linear-gradient(118deg, #212931 0%, #202B36 100%) 0% 0% no-repeat padding-box',
  minigamesGameWinningTimerWrapperBoxShadow: '3px 0px 12px #000000',
  minigamesGameWinningTimerWrapperBorder: '#3D4A5C',
  minigamesGameWinningPvpBorder: '#ff4040',
  minigamesGameWinnningPriceBg:
    'transparent linear-gradient(126deg, #3A434F 0%, #243343 100%) 0% 0% no-repeat padding-box',
  minigamesGameWinnningPriceBoxShadow: '3px 0px 12px #00000080',
  minigamesGameEntryFeeTimerBg:
    'transparent linear-gradient(134deg, #3A434F 0%, #243343 100%) 0% 0% no-repeat padding-box',
  minigamesGameEntryFeeTimerBoxShadow: '3px 0px 12px #00000080',
  minigamesGamePrizePoolTimerItemBorder: ' #596779',
  minigamesPlayBtnBg: ' linear-gradient(to bottom, #f6c53f, #ffc300)',
  minigamesPlayBtnBorder: '#fff079',
  minigamesGameInfoContainerBg: ' linear-gradient(123deg, #212931 8%, #202b36 96%)',
  minigamesGameInfoContainerBorder: '#3d4a5c',
  minigamesMatchFlagBg:
    'transparent linear-gradient(97deg, #212931 0%, #202B36 100%) 0% 0% no-repeat padding-box',
  minigamesMatchFlagBoxShadow: '3px 0px 12px #000000',
  mingamesPoolPrizeEntryFeeHeaderBg: '#192330 0% 0% no-repeat padding-box',
  minigamesPoolPrizeEntryFeeValueBg:
    'transparent linear-gradient(118deg, #3A434F 0%, #243343 100%) 0% 0% no-repeat padding-box',
  minigamesPoolPrizeEntryFeeValueBoxShadow: ' 3px 0px 12px #000000',
  gameInfoRuppeCoinBackDropBg: '#333D49 0% 0% no-repeat padding-box',
  gameInfoRuppeCoinBackDropBorder: '#596779',
  gameInfoWinningsArrowBg: '#161E29 0% 0% no-repeat padding-box',
  currentScorePillBorder: '#ffc400',
  highestScorePillBorder: '#cf74fc',
  //minigamesscoremodal

  minigamesScoreModalBg: '#121A24 0% 0% no-repeat padding-box',
  minigamesScoreModalBoxShadow: '0px 0px 6px #00000029',
  minigamesScoreModalBorder: '#FFC400'
};
